import { useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

export default function SiteTab({ content, enquiries, reload }) {
  const [form, setForm] = useState({
    tagline: content.tagline || "",
    phone: content.phone || "",
    email: content.email || "",
    areas_text: content.areas_text || "",
    facebook_url: content.facebook_url || "",
    instagram_url: content.instagram_url || "",
  });
  const [saving, setSaving] = useState(false);
  const input = "w-full bg-[#070b12] border border-white/15 rounded-xl px-4 py-2.5 text-sm text-white focus:border-[#1e9bff] outline-none";
  const label = "text-[10px] font-mono-lbl uppercase tracking-widest text-[#1e9bff] block mb-1";

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/content", form);
      toast.success("Site details saved");
      reload();
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-6" data-testid="site-tab">
      <div className="p-5 rounded-2xl bg-[#0b1322] border border-[#1e9bff]/20 space-y-3">
        <h3 className="font-display uppercase text-lg text-white">Site Details</h3>
        <div><label className={label}>Tagline</label>
          <input className={input} data-testid="site-tagline-input" value={form.tagline} onChange={(e) => setForm({ ...form, tagline: e.target.value })} /></div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div><label className={label}>Phone</label>
            <input className={input} data-testid="site-phone-input" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></div>
          <div><label className={label}>Email</label>
            <input className={input} data-testid="site-email-input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
          <div><label className={label}>Facebook URL</label>
            <input className={input} placeholder="https://facebook.com/…" data-testid="site-facebook-input" value={form.facebook_url} onChange={(e) => setForm({ ...form, facebook_url: e.target.value })} /></div>
          <div><label className={label}>Instagram URL</label>
            <input className={input} placeholder="https://instagram.com/…" data-testid="site-instagram-input" value={form.instagram_url} onChange={(e) => setForm({ ...form, instagram_url: e.target.value })} /></div>
        </div>
        <div><label className={label}>Areas covered text</label>
          <textarea rows={2} className={input} data-testid="site-areas-input" value={form.areas_text} onChange={(e) => setForm({ ...form, areas_text: e.target.value })} /></div>
        <button onClick={save} disabled={saving} data-testid="site-save-btn"
          className="px-6 py-2.5 rounded-xl bg-[#1e9bff] text-black text-xs font-bold uppercase tracking-wider hover:bg-[#60baff] transition-colors disabled:opacity-50">
          {saving ? "Saving…" : "Save Site Details"}
        </button>
      </div>

      <div className="p-5 rounded-2xl bg-[#0b1322] border border-[#1e9bff]/20">
        <h3 className="font-display uppercase text-lg text-white mb-4">Contact Form Messages</h3>
        {enquiries.length === 0 ? (
          <p className="text-sm text-[#93b4d4]" data-testid="enquiries-empty">No messages yet.</p>
        ) : (
          <div className="space-y-3" data-testid="enquiries-list">
            {enquiries.map((q) => (
              <div key={q.id} className="p-4 rounded-xl bg-[#070b12] border border-white/10" data-testid={`enquiry-${q.id}`}>
                <p className="text-sm text-white font-semibold">{q.name} <span className="text-[#627d98] font-mono-lbl text-xs">{q.email}{q.phone ? ` · ${q.phone}` : ""}</span></p>
                <p className="text-sm text-[#c8d9ea] mt-1">{q.message}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
